// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Stolmal Format — Design Tokens
 * SINGLE SOURCE OF TRUTH for colors, spacing, radius, shadows, motion.
 * All components MUST consume these via var(--token). Never hard-code colors.
 *
 * Palette derived from the brand logo (navy + antique gold, natural & precise):
 *   - Navy   #0B1B34  brand / dark surfaces
 *   - Gold   #C9A24B  single interactive color (buttons, links, focus)
 *   - Cream  #F5EFE0  light surface / page background
 *   - Ink    #1A1A1A  body text
 */

:root {
  /* ---------- Brand core ---------- */
  --color-navy: #0b1b34;
  --color-navy-600: #12274a;
  --color-navy-400: #223a63;
  --color-navy-200: #4a628a;

  --color-gold: #c9a24b;
  --color-gold-600: #b28a35;
  --color-gold-400: #d8b76a;
  --color-gold-200: #ecdcae;

  --color-cream: #f5efe0;
  --color-cream-600: #ebe3cf;
  --color-cream-200: #fbf7ec;

  --color-ink: #1a1a1a;
  --color-ink-600: #3a3a3a;
  --color-ink-400: #6b6b6b;
  --color-ink-200: #a8a8a8;

  --color-white: #ffffff;
  --color-black: #000000;

  /* Feedback (kept neutral, harmonized with palette) */
  --color-success: #4a7c59;
  --color-warning: #d99a2b;
  --color-danger: #b3453a;

  /* ---------- Semantic aliases (use these in components) ---------- */
  --bg-page: var(--color-cream);
  --bg-surface: var(--color-white);
  --bg-surface-alt: var(--color-cream-600);
  --bg-inverse: var(--color-navy);

  --text-primary: var(--color-ink);
  --text-secondary: var(--color-ink-600);
  --text-muted: var(--color-ink-400);
  --text-on-dark: var(--color-cream-200);
  --text-on-accent: var(--color-navy);

  --brand-primary: var(--color-navy);
  --brand-accent: var(--color-gold);

  /* All clickable elements use ONE color: gold. */
  --interactive: var(--color-gold);
  --interactive-hover: var(--color-gold-600);
  --interactive-active: var(--color-gold-400);
  --interactive-disabled: var(--color-ink-200);
  --interactive-fg: var(--color-navy);

  --border-subtle: rgba(11, 27, 52, 0.12);
  --border-strong: rgba(11, 27, 52, 0.32);
  --focus-ring: rgba(201, 162, 75, 0.55);

  /* Back-compat alias */
  --white: var(--color-white);

  /* ---------- Shape ---------- */
  --radius-sm: 6px;
  --radius: 12px;
  --radius-lg: 20px;
  --radius-pill: 999px;

  /* ---------- Elevation ---------- */
  --shadow-sm: 0 1px 2px rgba(11, 27, 52, 0.08);
  --shadow: 0 4px 16px rgba(11, 27, 52, 0.12);
  --shadow-lg: 0 12px 32px rgba(11, 27, 52, 0.18);

  /* ---------- Motion ---------- */
  --transition: 0.22s ease;
  --transition-slow: 0.35s ease;
}
`, "",{"version":3,"sources":["webpack://./src/shared/styles/tokens.css"],"names":[],"mappings":"AAAA;;;;;;;;;;EAUE;;AAEF;EACE,qCAAqC;EACrC,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;;EAEzB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;;EAEzB,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;;EAE1B,oBAAoB;EACpB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;;EAExB,sBAAsB;EACtB,sBAAsB;;EAEtB,qDAAqD;EACrD,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;;EAEvB,qEAAqE;EACrE,6BAA6B;EAC7B,gCAAgC;EAChC,wCAAwC;EACxC,+BAA+B;;EAE/B,gCAAgC;EAChC,sCAAsC;EACtC,kCAAkC;EAClC,sCAAsC;EACtC,mCAAmC;;EAEnC,kCAAkC;EAClC,iCAAiC;;EAEjC,gDAAgD;EAChD,gCAAgC;EAChC,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;EAC5C,mCAAmC;;EAEnC,uCAAuC;EACvC,uCAAuC;EACvC,sCAAsC;;EAEtC,sBAAsB;EACtB,2BAA2B;;EAE3B,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;;EAEpB,oCAAoC;EACpC,6CAA6C;EAC7C,2CAA2C;EAC3C,+CAA+C;;EAE/C,iCAAiC;EACjC,wBAAwB;EACxB,6BAA6B;AAC/B","sourcesContent":["/**\n * Stolmal Format — Design Tokens\n * SINGLE SOURCE OF TRUTH for colors, spacing, radius, shadows, motion.\n * All components MUST consume these via var(--token). Never hard-code colors.\n *\n * Palette derived from the brand logo (navy + antique gold, natural & precise):\n *   - Navy   #0B1B34  brand / dark surfaces\n *   - Gold   #C9A24B  single interactive color (buttons, links, focus)\n *   - Cream  #F5EFE0  light surface / page background\n *   - Ink    #1A1A1A  body text\n */\n\n:root {\n  /* ---------- Brand core ---------- */\n  --color-navy: #0b1b34;\n  --color-navy-600: #12274a;\n  --color-navy-400: #223a63;\n  --color-navy-200: #4a628a;\n\n  --color-gold: #c9a24b;\n  --color-gold-600: #b28a35;\n  --color-gold-400: #d8b76a;\n  --color-gold-200: #ecdcae;\n\n  --color-cream: #f5efe0;\n  --color-cream-600: #ebe3cf;\n  --color-cream-200: #fbf7ec;\n\n  --color-ink: #1a1a1a;\n  --color-ink-600: #3a3a3a;\n  --color-ink-400: #6b6b6b;\n  --color-ink-200: #a8a8a8;\n\n  --color-white: #ffffff;\n  --color-black: #000000;\n\n  /* Feedback (kept neutral, harmonized with palette) */\n  --color-success: #4a7c59;\n  --color-warning: #d99a2b;\n  --color-danger: #b3453a;\n\n  /* ---------- Semantic aliases (use these in components) ---------- */\n  --bg-page: var(--color-cream);\n  --bg-surface: var(--color-white);\n  --bg-surface-alt: var(--color-cream-600);\n  --bg-inverse: var(--color-navy);\n\n  --text-primary: var(--color-ink);\n  --text-secondary: var(--color-ink-600);\n  --text-muted: var(--color-ink-400);\n  --text-on-dark: var(--color-cream-200);\n  --text-on-accent: var(--color-navy);\n\n  --brand-primary: var(--color-navy);\n  --brand-accent: var(--color-gold);\n\n  /* All clickable elements use ONE color: gold. */\n  --interactive: var(--color-gold);\n  --interactive-hover: var(--color-gold-600);\n  --interactive-active: var(--color-gold-400);\n  --interactive-disabled: var(--color-ink-200);\n  --interactive-fg: var(--color-navy);\n\n  --border-subtle: rgba(11, 27, 52, 0.12);\n  --border-strong: rgba(11, 27, 52, 0.32);\n  --focus-ring: rgba(201, 162, 75, 0.55);\n\n  /* Back-compat alias */\n  --white: var(--color-white);\n\n  /* ---------- Shape ---------- */\n  --radius-sm: 6px;\n  --radius: 12px;\n  --radius-lg: 20px;\n  --radius-pill: 999px;\n\n  /* ---------- Elevation ---------- */\n  --shadow-sm: 0 1px 2px rgba(11, 27, 52, 0.08);\n  --shadow: 0 4px 16px rgba(11, 27, 52, 0.12);\n  --shadow-lg: 0 12px 32px rgba(11, 27, 52, 0.18);\n\n  /* ---------- Motion ---------- */\n  --transition: 0.22s ease;\n  --transition-slow: 0.35s ease;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
